export default {
  smartRow1: '杰为采用先进的MASA、DevOps和容器架构，构建了用于设计、研发、制造和质量的现代应用，直观性强，可快速灵活部署到任何硬件。通过消对硬件和数据库的依赖性，无需中断，轻松部署新的应用程序，该应用可在其他流程中重复使用，降低IT基础架构的成本。杰为的低代码或无代码开发平台赋能IT / OT团队，开发自用的应用程序去完成特定的制造过程和任务。'
}
